import moment from 'moment'

import * as mutationTypes from 'store/mutationTypes'
import dateUtils from 'utils/dateUtils'
import * as actions from './actions'

function getCurrentDate() {
  let date = new Date()
  date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)

  const defaultDate = dateUtils.toUTCMomentWithoutTime(date)
  const now = moment()
  const isToday = now.isSame(defaultDate, 'd')

  // if it is before 6AM lets go back a day incase a venue is looking after midnight
  if (isToday && now.hours() < 6) {
    date = new Date(
      defaultDate.get('year'),
      defaultDate.get('month'),
      defaultDate.get('date') - 1,
      0,
      0,
      0,
      0
    )
  }

  return moment(date.toISOString())
}

export default {
  state: {
    current: getCurrentDate(),
  },
  actions,
  mutations: {
    [mutationTypes.SET_CURRENT_DATE](state, date) {
      state.current = date
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/date/index.js